export default __webpack_public_path__ + "static/media/PHÂN HỆ QUẢN LÝ KHÁM BỆNH.264bf527.pdf";